interface NavLinkBase {
  label: string;
}

type NavLinkWithrouteName = NavLinkBase & {
  routeName: string;
  index?: string;
  sublinks?: never;
};

type NavLinkWithSublinks = NavLinkBase & {
  routeName?: never;
  index?: never;
  sublinks: NavLinkWithrouteName[];
};

export type NavLink = NavLinkWithrouteName | NavLinkWithSublinks;

export const Routes: NavLink[] = [
  {
    label: 'Dashboard',
    routeName: 'admin.dashboard',
  },
  {
    label: 'Course',
    sublinks: [
      {
        label: 'Categories',
        routeName: 'admin.course.category',
      },
      {
        label: 'Listings',
        routeName: 'admin.course.listing',
      },
      {
        label: 'Applicants',
        routeName: 'admin.course.applicant',
      },
    ],
  },
  {
    label: 'Online Shoppe',
    sublinks: [
      {
        label: 'Groups',
        routeName: 'admin.shoppe.group',
      },
      {
        label: 'Categories',
        routeName: 'admin.shoppe.category',
      },
      {
        label: 'Sub Categories',
        routeName: 'admin.shoppe.subCategory',
      },
      {
        label: 'Products',
        routeName: 'admin.shoppe.product',
      },
      {
        label: 'Colors',
        routeName: 'admin.shoppe.color',
      },
      {
        label: 'Sizes',
        routeName: 'admin.shoppe.size',
      },
      {
        label: 'Vendors',
        routeName: 'admin.shoppe.vendor',
      },
      {
        label: 'Discount Codes',
        routeName: 'admin.shoppe.discountCode',
      },
      {
        label: 'Orders',
        routeName: 'admin.shoppe.order',
      },
    ],
  },
  {
    label: 'Service',
    sublinks: [
      {
        label: 'Listings',
        routeName: 'admin.service.listing',
      },
      {
        label: 'Orders',
        routeName: 'admin.service.order',
      },
    ],
  },
  {
    label: 'Career',
    sublinks: [
      {
        label: 'Jobs',
        routeName: 'admin.job',
      },
      {
        label: 'Job Applicants',
        routeName: 'admin.jobApplicant',
      },
    ],
  },
  {
    label: 'Customer Management',
    sublinks: [
      {
        label: 'Customers',
        routeName: 'admin.customer',
      },
      {
        label: 'Subscribers',
        routeName: 'admin.subscriber',
      },
      {
        label: 'Newsletter Subscribers',
        routeName: 'admin.newsletter',
      },
      {
        label: 'Leads',
        routeName: 'admin.lead',
      },
      {
        label: 'Visitors',
        routeName: 'admin.visitor',
      },
      {
        label: 'Cash Register',
        routeName: 'admin.cashRegister',
      },
    ],
  },
  {
    label: 'Contact',
    routeName: 'admin.contact',
  },
  {
    label: 'Payment Methods',
    routeName: 'admin.paymentMethod',
  },
  {
    label: 'FAQs',
    routeName: 'admin.faq',
  },
  {
    label: 'Inquiries',
    routeName: 'admin.inquiry',
  },
  {
    label: 'SEO',
    routeName: 'admin.seo',
  },
  {
    label: 'User Management',
    sublinks: [
      {
        label: 'Users',
        routeName: 'admin.user',
      },
      {
        label: 'Roles',
        routeName: 'admin.role',
      },
    ],
  },
];
